import styled from 'styled-components';

export const CheckoutContentBlock = styled.div`
  display: flex;
  & > .title {
    font-size: 1.125rem;
    font-weight: bold;
    margin: 1.5rem 0 0.75rem 0;
  }

  & > span.disabled-to-buy {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.red};
    margin-left: auto;
    margin-top: 0.5rem;
  }
`;

export const TitleContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  padding: 0.75rem 1.875rem;
  margin-top: 2rem;
`;

export const TableContainer = styled.div`
  padding: 1rem 1.875rem;
  background-color: ${({ theme }) => theme.colors.gray8};
`;

export const CheckoutContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding-bottom: 1rem;
  margin: 0.5rem 0 0;
`;
